import Api from '@/utils/api';

const mockMethods = {
  methods: [
    //
    {
      name: 'Quick Check',
      lock: true,
      status: 'active',
      description: 'evaluation method with error category, error severity, superordinate rule, translation quality statement',
    },
    {
      name: 'Deep Scan',
      lock: true,
      status: 'active',
      description: 'evaluation method with error category, error severity, superordinate rule, translation quality statement',
    },
    {
      name: 'QA report (CSV)',
      lock: false,
      status: 'active',
      description: 'evaluation method with error category, error severity, superordinate rule, translation quality statement',
    },
    {
      name: 'QA report CAT tool',
      lock: false,
      status: 'inactive',
      description: 'evaluation method with error category, error severity, superordinate rule, translation quality statement',
    },
  ],
  getMethods() {
    return new Promise((res, rej) => {
      setTimeout(() => {
        res({
          status: 200,
          data: this.methods,
        });
      }, 500);
    });
  },
};

export default {
  data() {
    return {
      evaluationTypes: [],
      evaluationMethods: [],
      newEvaluationMethod: {
        name: '',
        lock: false,
        status: 'active',
        description: '',
      },
    };
  },
  created() {
    this.getEvaluationMethods();
  },
  methods: {
    clearNewEvaluationMethod() {
      this.newEvaluationMethod = {
        name: '',
        lock: false,
        status: 'active',
        description: '',
      };
    },
    getEvaluationMethods() {
      Api.getEvaluationTypes()
        .then((res) => {
          if (res.status === 200) {
            this.evaluationTypes = res.data;
          }
        })
        .catch((err) => {
          this.$root.$emit('notification', {
            message: `Error, ${err} `,
            type: 'error',
            show: true,
          });
        });

      mockMethods.getMethods()
        .then((res) => {
          if (res.status === 200) {
            this.evaluationMethods = res.data;
          }
        })
        .catch((err) => {
          this.$root.$emit('notification', {
            message: `Error, ${err} `,
            type: 'error',
            show: true,
          });
        });
    },
    addNewMethod() {
      this.clearNewEvaluationMethod();
      this.$modal.show('newEvaluationMethod');
    },
    submitNewMethod() {
      this.$validator.validateAll()
        .then(() => {
          // success
        }).catch(() => {
          // Failed
        });
    },
    editMethod(method) {
      this.newEvaluationMethod = {
        ...method,
      };
      this.$modal.show('newEvaluationMethod');
    },
    duplicateMethod(method, idx) {
      this.evaluationMethods[idx + 1] = method;
    },
    confirmRemove(method) {
      this.$modal.show('dialog', {
        title: 'Confirm Delete',
        text: 'Do you want to delete this method?',
        buttons: [{
          title: 'Yes',
          handler: () => {
            this.removeMethod(method);
            this.$modal.hide('dialog');
          },
        }, {
          title: 'No',
        }],
      });
    },
    removeMethod(method) {},
  },
};
